import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Player from './views/Player.vue';
import NotFound from './views/NotFound.vue';
import NotUploaded from './views/NotUploaded.vue';
import capabilities from '@/utils/capabilities';

// import CookiePolicy from './views/CookiePolicy.vue';

import store from './store';
import { Logger } from 'aws-amplify';

const logger = new Logger('Router');

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '',
      name: 'home',
      component: Home,
      props: true,
    },
    {
      path: '/:id',
      name: 'player',
      component: Player,
      props: true,
    },
    {
      path: '/notfound',
      name: 'NotFound',
      component: NotFound,
    },
    {
      path: '/notuploaded',
      name: 'NotUploaded',
      component: NotUploaded,
    },
    /*
    {
      path: '/cookiepolicy',
      name: 'CookiePolicy',
      component: CookiePolicy,
    },
    */
  ],
});


router.beforeResolve(async (to, from, next) => {
  // Reset iframe player state
  store.commit('playbackStarted', false);
  store.commit('playState', 0);

  if (to.name === 'player') {
    document.title = `${to.params.id}`;
    await capabilities(to.params.id);
  } else {
    document.title = 'LiveSYNC Reader';
  }
  return next();
});

export { router as default };
